import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import routes from "../../config/routes.json";
import { makeHttpCall } from "../../utils/HttpHelpers";
import { getBaseUrl } from "../../utils/QueryString";

function RedirectPage(props) {

  const {setIsLogin, onSetAppId} = props;
  const [error, setError] = useState(false);
  const params = useParams();
  const history = useHistory();

  const url = `https://${getBaseUrl()}/v1/translationkey_mappings.json?include_translations=1&include_translatable=1&translation_language=mbox.landing.config&translatable_type=App&translatable_id=${params.id}&smart_find=0`;

  const getLoginCred = async () => {
    localStorage.setItem("app_id", params.id);
    if(onSetAppId) onSetAppId(params?.id);
    const apiRes = await makeHttpCall({
      url: url,
      method: "GET",
      isVm: true,
    });

    if (apiRes?.ok) {
      const value = JSON.parse(
        apiRes.data[0].translationkey.translations[0].value
      );

      if (value?.loginCredentials) {
        history.push({
          pathname: routes.LOGIN,
          state: {
            appId: params.id,
            base_url:getBaseUrl(),
            credentials: {
              ...value.loginCredentials,
            },
          },
        });
      } else {
        setError(true);
      }
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const appId = localStorage.getItem("app_id");
    const userRole = localStorage.getItem("role");
    const storageAppId = localStorage.getItem("app_id");

    if ((Number(storageAppId) === Number(params.id)) && !!accessToken && !!appId && !!userRole) {
      history.push({
        pathname: routes.EVENTS,
      });
    } else {
      localStorage.removeItem("app_id");
      localStorage.removeItem("role");
      localStorage.removeItem("event_id");
      localStorage.removeItem("event_title");
      localStorage.removeItem("user_name");
      localStorage.removeItem("event_ends_at");
      localStorage.removeItem("event_starts_at");
      localStorage.removeItem("access_token");
      localStorage.removeItem("mboxSeletah.user");
      setIsLogin(false);
      getLoginCred();
    }
  }, []);

  if (error) {
    return (
      <div
        style={{
          width: "100%",
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
        }}
      >
        Login credentials are missing, please use oca link for login
      </div>
    );
  }

  return <div>RedirectPage {params.id}</div>;
}

export default RedirectPage;
